import GeneralTranslations from "../../../Common/ModuleTranslations/es";

export default {
  locale: "es",
  name: "Modificación de reserva",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "ticker",
        displayName: "Identificador",
      },
      {
        fieldName: "conditionRates",
        displayName: "Condiciones",
      },
      {
        fieldName: "canModifyDates",
        displayName: "Modificar Fechas",
      },
      {
        fieldName: "canModifyAccommodations",
        displayName: "Modificar Alojamientos",
      },
      {
        fieldName: "excludedStayDates",
        displayName: "Fechas de Estancia Excluida",
      },
      {
        fieldName: "maxAllowedChanges",
        displayName: "Límite de Mod.",
      },
      {
        fieldName: "dates",
        displayName: "Fechas de Modificación",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "Ticker del hotel",
        widget: "hidden",
      },
      {
        fieldName: "ticker",
        displayName: "Identificador",
        widget: "input",
        className: "tickerInput",
      },
      {
        fieldName: "rateTypeSection",
        displayName: "Modificar fechas",
        widget: "section",
      },

      {
        fieldName: "canModifyDates",
        widget: "singleSwitch",
        displayName: "Activado:",
      },
      {
        fieldName: "datesMinRelease",
        displayName: "Mínima antelación para la modificación (dias):",
        widget: "input",
      },
      {
        fieldName: "excludedStayDatesSection",
        displayName: "Fechas de estancia excluidas",
        widget: "section",
        className: "noBorderNoMargin",
      },
      {
        fieldName: "excludedStayDates",
        introductionText: [],
        widget: "nestedEntity",
        nested: true,
        entityName: "modificationBookingWindow",
        nestedTitle: "Fechas de estancia excluidas",
        minHeight: 500,
        defaultValue: [],
      },
      {
        fieldName: "datesModificationRestrictionType",
        widget: "selector",
        displayName: "Solo si:",
        className: "datesSelector",
        optionDisplay: {
          AMOUNT_AND_STAY_GTE: {
            label: "Es igual o superior a la duración de la estancia y el importe de la misma",
          },
          STAY_GTE: {
            label: "Se iguale o supere la duración de la estancia",
          },
          AMOUNT_GTE: {
            label: "Se iguale o supere el importe de la estancia.",
          },
          NO_RESTRICTION: {
            label: "Libertad total para el cambio de fechas.",
          },
        },
      },
      {
        fieldName: "accommodationSection",
        displayName: "Modificar alojamiento",
        widget: "section",
      },
      {
        fieldName: "canModifyAccommodations",
        widget: "singleSwitch",
        displayName: "Activado:",
      },
      {
        fieldName: "accommodationMinRelease",
        displayName: "Antelación mínima para modificaciones (días):",
        widget: "input",
      },
      {
        fieldName: "accommodationModificationRestrictionType",
        displayName: "Solo si:",
        widget: "selector",
        optionDisplay: {
          AMOUNT_GTE: {
            label: "Se iguale o supere el importe de la estancia.",
          },
          NO_RESTRICTION: {
            label: "Libertad total para el cambio de opción de alojamiento.",
          },
        },
      },
      {
        fieldName: "canChangeConditions",
        widget: "singleSwitch",
        displayName: "Cambio de tarifa:",
        helpText:
          "Permitir modificación de reserva a otra condición/tarifa disponible. (ej: de CG a NR)",
      },
      {
        fieldName: "conditionSection",
        displayName: "Se aplica a las condiciones:",
        widget: "section",
      },
      {
        fieldName: "conditions",
        widget: "multicheckbox",
        visible: ({ formValues, entity }) => entity.ticker !== "DEFAULT",
      },
      {
        fieldName: "restrictionsSection",
        displayName: "Restricciones",
        widget: "section",
      },
      {
        fieldName: "maxAllowedChanges",
        displayName: "Máximo número de modificaciones",
        widget: "input",
      },
      {
        fieldName: "modificationAllowedFrom",
        displayName: "Fechas de modificación",
        placeholder: "Introduce una fecha",
      },
      {
        fieldName: "modificationAllowedUntil",
        placeholder: "Introduce una fecha",
      },
    ],
  },
};
